import { Entity } from '../../../core/models/entity.model';

export interface UserSettingsEntityState {
  userSettingsEntity: Entity;
  error: any;
  userSettingsEntityLoading: boolean;
}

export const initialState: UserSettingsEntityState = {
  userSettingsEntity: null,
  error: null,
  userSettingsEntityLoading: false
};
